







































































import { Component, Prop, Vue } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import FeedbackIcon from '@/components/icons/Feedback.vue';
import CloseIcon from '@/components/icons/Close.vue';
import ArrowBack from '@/components/icons/Arrow.vue';
import SuccessFeedback from '@/components/icons/SuccessFeedback.vue';
import StepsIndicator from '@/views/Onboarding/Steps/StepsIndicator/StepsIndicator.vue';

import { formatStepsToArray } from '@/views/Onboarding/helpers';
import eventBus from '@/utils/eventBus';
import FeedbackService from '@/api/FeedbackService';
import {
  EFeedbackDeactivationType,
  TFeedbackDeactivationType
} from '@/models/feedback';
import segmentIo from '@/utils/segment.io';
import { capitalizeWords } from '@/utils';

import DeactivationReasons from './Steps/DeactivationReasons.vue';
import DeactivationComment from './Steps/DeactivationComment.vue';
import DeactivationFeatures from '../../molecules/FeaturesList/FeaturesList.vue';
import { IBusinessType } from '@/models/business';
import AlertsService from '@/api/AlertsService';

@Component({
  components: {
    FilledButton,
    FeedbackIcon,
    SuccessFeedback,
    CloseIcon,
    ArrowBack,
    StepsIndicator,
    DeactivationReasons,
    DeactivationComment,
    DeactivationFeatures
  }
})
export default class DeactivationReviewModal extends Vue {
  @Prop() type!: TFeedbackDeactivationType;
  @Prop() onSuccess!: Function;

  availableFeatures: any[] = [];

  features = [
    {
      value: 'rewardProgram',
      title: 'Loyalty Rewards Program',
      warning: true,
      warningText:
        this.isOnlineOnly && this.businessNotInUS
          ? "Members who already have an account will continue receiving Coins when they make a purchase. To deactivate rewards, it's necessary to"
          : "Your Loyalty Rewards Program remains active and members can still access their wallets via the Twism mobile app to track and redeem their Loyalty Rewards. To deactivate rewards, it's necessary to",
      icon: 'reward-ratio'
    },
    { value: 'welcomeCoins', title: 'Welcome Coins', icon: 'welcome-coins' },
    {
      value: 'referralProgram',
      title: 'Referral Program',
      icon: 'referral'
    },
    {
      value: 'socialRewards',
      title: 'Social Rewards',
      icon: 'social-rewards'
    },
    {
      value: 'inviteCustomers',
      title: 'Invite Customers',
      icon: 'invite-customers'
    },
    {
      value: 'emailAutomation',
      title: 'Email automation',
      icon: 'email-automation'
    }
  ];

  stepMapper: Record<number, any> = {
    1: {
      components: [{ component: 'DeactivationReasons' }]
    },
    2: {
      components: [{ component: 'DeactivationComment' }]
    },
    3: {
      components: [{ component: 'DeactivationFeatures' }]
    }
  };

  service = new FeedbackService();
  serviceAlert = new AlertsService();
  comment: string = '';
  success = false;
  loading = false;
  stepIndicator = {
    main: 1,
    internal: 0,
    currentIndex: 0
  };

  EFeedbackDeactivationType = EFeedbackDeactivationType;

  form: any = {};

  get tPrefix() {
    return 'common.components.feedbackDisconnectV2';
  }

  get business() {
    if (!this.$store.getters['business/getBusinessInfo']) return {};
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get stepText() {
    return `step-${this.stepIndicator.main}`;
  }

  get formatedStepComponents() {
    return formatStepsToArray(this.stepMapper);
  }

  get businessNotInUS() {
    return this.business.country !== 'United States';
  }

  get isOnlineOnly() {
    return this.business.type === IBusinessType.ONLINE;
  }

  get selectedOptions() {
    const selected: any = {};

    Object.keys(this.form).forEach(key => {
      if (this.form[key]) {
        selected[key] = true;
      }
    });

    return selected;
  }

  get provider() {
    if (this.$store.getters['merchant/getCurrentProvider'])
      return this.$store.getters['merchant/getCurrentProvider'].name;
    return '';
  }

  get tPrefixDisclaimer() {
    return `${this.tPrefix}${
      this.stepIndicator.main === 3 ? `.${this.stepText}` : ''
    }`;
  }

  changeComment(comment: string) {
    this.comment = comment;
  }

  changeReasons() {
    segmentIo.track('Selected Deactivation Review Reason', {
      value: JSON.stringify(Object.keys(this.selectedOptions))
    });
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  onBack() {
    this.stepIndicator.main--;
  }

  async onSubmit() {
    try {
      if (this.stepIndicator.main !== 3) {
        segmentIo.track('Clicked Deactivation Review Next');
        this.stepIndicator.main++;
        return;
      }
      segmentIo.track('Clicked Deactivation Review Submit');
      this.loading = true;

      await this.service.sendFeedbackDeactivation(this.type, {
        rating: 0,
        comment: this.comment,
        reasons: Object.keys(this.selectedOptions),
        provider: this.provider
      });
      this.onSuccess();
      this.success = true;
    } finally {
      this.loading = false;
    }
  }

  async created() {
    segmentIo.modal(`Review ${capitalizeWords(this.type.replace('-', ' '))}`);

    const { data } = await this.serviceAlert.getDeactivationWidgetFeatures();
    this.availableFeatures = data;
    const featuresAvailables = Object.keys(this.availableFeatures);
    this.features = this.features.filter(feature =>
      featuresAvailables.includes(feature.value)
    );
  }

  onSuccessClick() {
    this.onClose();
  }
}
